import axios from "axios";

axios.defaults.baseURL = `${process.env.REACT_APP_API_BASE_URL}/api`;
axios.defaults.headers.common["Content-Type"] = "application/json";
